export default __webpack_public_path__ + "static/media/fad-prev.6ba64b79.svg";